import React from "react";
import { Box, Button, Center, Popover, Text } from "@mantine/core";

interface DocsButtonProps {
  ariaLabel: string;
  text: string;
  leftSection: React.ReactNode;
  disabled?: boolean;
}

const DocsButton: React.FC<DocsButtonProps> = ({
  ariaLabel,
  text,
  leftSection,
  disabled = false,
}) => (
  <Box mb={"20px"}>
    <Center>
      <Popover
        zIndex={2000}
        width={250}
        position="bottom"
        withArrow
        shadow="md"
      >
        <Popover.Target>
          <Button
            leftSection={leftSection}
            aria-label={ariaLabel}
            variant="default"
            disabled={disabled}
          >
            {text}
          </Button>
        </Popover.Target>
        <Popover.Dropdown>
          <Text size="xs">
            This is just the documentation, so this button doesn't do anything.
            Look for this button in the Rizful interface and use it there.
          </Text>
        </Popover.Dropdown>
      </Popover>
    </Center>
  </Box>
);

export default DocsButton;
